module.exports = "/_next/static/images/confidential-9f0cd924c09c9fe4b3f4723e8fbb9ee0.jpg";